import { apiClient } from '@/lib/api';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { Invitation, CreateInvitationData } from '../types/invitation.types';

class InvitationService {
  async list(): Promise<Invitation[]> {
    return apiClient.get(ENDPOINTS.INVITATIONS);
  }

  async create(data: CreateInvitationData): Promise<Invitation> {
    return apiClient.post(ENDPOINTS.INVITATIONS, data);
  }

  async revoke(id: string): Promise<void> {
    return apiClient.delete(ENDPOINTS.INVITATION_BY_ID(id));
  }
}

export const invitationService = new InvitationService();
